export default "__VITE_ASSET__H6$xwM5n__"